import { lazy } from "react";

export const SearchPage = lazy(() => import("./search/Search"));
export const VenuePage = lazy(() => import("./venue/Venue"));
export const CreateVenuePage = lazy(() => import("./create-venue/CreateVenue"));
export const DashboardPage = lazy(() => import("./dashboard/Dashboard"));
export const CreateStagePage = lazy(() => import("./create-stage/CreateStage"));
export const EditVenueBrandingPage = lazy(
  () => import("./edit-venue/Branding/Branding")
);
export const StagePage = lazy(() => import("./stage/Stage"));
export const EditVenuePage = lazy(() => import("./edit-venue/EditVenue"));
export const EditStagePage = lazy(() => import("./edit-stage/EditStage"));
export const EditVenueEquipmentPage = lazy(
  () => import("./edit-venue/Equipment/EditVenueEquipment")
);
export const EditEquipmentBlockPage = lazy(
  () => import("./edit-stage/Equipment/EditEquipmentBlock")
);
export const EditVenueInfoBlock = lazy(
  () => import("./edit-venue/InfoBlock/EditVenueInfoBlock")
);
export const EditStageInfoBlock = lazy(
  () => import("./edit-stage/InfoBlock/EditStageInfoBlock")
);
